// Api
import AxiosClient from '@api/axiosClient';
// Urls
import { urls } from './urls';
// Models
import { ICreateFreeDemo, ICreateLead, ICreateTransaction, IRedeemCode, ISendNotification } from '@models/Plans';
import { IPlanApiResponse } from '@redux/plans/types';

export const apiGetActivePlans = <T>(): Promise<T> => AxiosClient.get(urls.payment.plans, {});

export const apiGetPlansEmployee = <T>(): Promise<T> => AxiosClient.get(urls.payment.getPayments);

export const apiGetTransaction = <T>(): Promise<T> => AxiosClient.get(urls.payment.statusPurchase);

export const apiPostCreateTransaction = <T>(data: ICreateTransaction): Promise<T> =>
    AxiosClient.post(urls.payment.createTransaction, data);

export const apiPostCreateFreeDemoTransaction = (data: ICreateFreeDemo): Promise<IPlanApiResponse> =>
    AxiosClient.post(urls.payment.createFreeDemoTransaction, data);

export const apiPostSupportTransaction = <T>(data: any): Promise<T> => AxiosClient.post(urls.payment.supportTransaction, data);

export const apiPostCreateLead = <T>(data: ICreateLead): Promise<T> => AxiosClient.post(urls.payment.createLead, data);

export const apiPostRedeemCode = <T>(data: IRedeemCode): Promise<T> => AxiosClient.post(urls.payment.redeemCode, data);

export const apiPostSendWelcomeNotification = <T>(data: ISendNotification): Promise<T> =>
    AxiosClient.post(urls.payment.sendWelcomeNotification, data);

export const apiGetPromotion = <T>(periodicityId: string): Promise<T> =>
    AxiosClient.get(urls.payment.getPromotion(periodicityId));
